<template>
	<div class="wrap">
		<div class="container">
			<h3 class="personal_titile">编辑我的个人资料</h3>
			<form v-if="user_info.user_info !== undefined && user_info.user_info != null">
				<p class="my_tit">个人信息</p>
				<div class="adddz profile chardz">
					<van-row type="flex" align="center" justify="space-between">
						<van-col span="11" class="address_require">
							<label>姓名<span>*</span></label>
							<input type="text" maxlength="50" value="" v-model="user_info.username" required>
						</van-col>
						<van-col span="11" class="address_require">
							<label>邮箱地址<span>*</span></label>
							<input type="email" value="" v-model="user_info.email" required>
						</van-col>
					</van-row>
					<div class="address_require">
						<label>我的生日</label>
						<van-row type="flex" align="center" justify="space-between">
							<van-col span="7" class="">
								<input type="number" maxlength="50" value="" min="0" max="31" placeholder="Day" v-model="user_info.user_info.birthday_day">
							</van-col>
							<van-col span="7" class="">
								<input type="number" maxlength="50" value="" min="0" max="12" placeholder="Month" v-model="user_info.user_info.birthday_month">
							</van-col>
							<van-col span="7" class="">
								<input type="number" maxlength="50" value="" placeholder="Year" v-model="user_info.user_info.birthday_year">
							</van-col>
						</van-row>
					</div>
				</div>
				<!-- <p class="my_tit">Personal Information</p> -->
				<!-- <div class="adddz profile">
					<div class="address_require">
						<label>My Occupation</label>
						<van-radio-group v-model="user_info.user_info.occupation" direction="horizontal">
							<van-radio icon-size="16px" checked-color="#FE7A72" v-for="(value,index) in personal_show_list.my_occupation" :key="index" :name="index" >{{value}}</van-radio>
						</van-radio-group>
					</div>
					<div class="address_require">
						<label>My Hair Color</label>
						<van-radio-group v-model="user_info.user_info.hair_color" direction="horizontal">
							<van-radio icon-size="16px" checked-color="#FE7A72" v-for="(value,index) in personal_show_list.my_hair_color" :key="index" :name="index">
								{{value}}</van-radio>
						</van-radio-group>
					</div> -->
					<!-- <div class="address_require">
						<label>My Head Size</label>
						<van-row type="flex" align="center" justify="space-between">
							<van-col span="11" class="">
								<input type="number" value="" placeholder="Ear to Ear Length (Front)" v-model="user_info.user_info.ear_to_ear_length_front">
							</van-col>
							<van-col span="11" class="">
								<input type="number" value="" placeholder="Hairline to Nape Length" v-model="user_info.user_info.hairline_to_nape_length">
							</van-col>
						</van-row>
						<van-row type="flex" align="center" justify="space-between">
							<van-col span="11" class="address_require">
								<input type="number" value="" placeholder="Ear to Ear Length (back)" v-model="user_info.user_info.ear_to_ear_length_back">
							</van-col>
							<van-col span="11" class="address_require">
								<input type="number" value="" placeholder="Head Circumference" v-model="user_info.user_info.head_circumference">
							</van-col>
						</van-row>
					</div>
				</div>
				<p class="my_tit">My Preference</p>
				<div class="adddz profile" style="border-bottom: none;">
					<div class="address_require">
						<label>My Preferable Hair Pattern</label>
						<van-radio-group v-model="user_info.user_info.preferable_hair_pattern" direction="horizontal">
							<van-radio icon-size="16px" checked-color="#FE7A72" v-for="(value,index) in personal_show_list.my_preferable_hair_pattern" :key="index" :name="index">
								{{value}}</van-radio>
						</van-radio-group>
					</div>
					<div class="address_require">
						<label>My Preferable Hair Length</label>
						<van-radio-group v-model="user_info.user_info.preferable_hair_length" direction="horizontal">
							<van-radio icon-size="16px" checked-color="#FE7A72" v-for="(value,index) in personal_show_list.my_preferable_hair_length" :key="index" :name="index">
								{{value}}</van-radio>
						</van-radio-group>
					</div>
					<div class="address_require">
						<label>My Preferable Parting Size</label>
						<van-radio-group v-model="user_info.user_info.preferable_parting_size" direction="horizontal">
							<van-radio icon-size="16px" checked-color="#FE7A72" v-for="(value,index) in personal_show_list.my_preferable_parting_size" :key="index" :name="index">
								{{value}}</van-radio>
						</van-radio-group>
					</div>
				</div> -->
				<van-row type="flex" align="center" justify="center" style="margin-top: 20px;">
					<van-col span="20" @click="saveInfo">
						<van-button block type="primary">保存</van-button>
					</van-col>
				</van-row>
			</form>
		</div>
		<v-foot></v-foot>
	</div>
</template>

<script>
	// @ is an alias to /src
	export default {
		components: {},
		created() {
			this.getData();
			this.getUserInfo(true);

		},
		data() {
			return {
				occupation: '1',
				color: '1',
				pattern: '1',
				length: '1',
				size: '1',
				personal_show_list: {},
				user_info: {},
			}
		},
		methods: {
			getData(){
				var url = "api/personal/index";
				var _self = this;

				this.GET(url,function (ret) {
					if(ret.code === 0){
						_self.personal_show_list = ret.data.personal_show_list;
						_self.user_info 	     = ret.data.user_info;

						_self.user_info.user_info.birthday_day = Number(_self.user_info.user_info.birthday_day);
						_self.user_info.user_info.birthday_month = Number(_self.user_info.user_info.birthday_month);
						_self.user_info.user_info.birthday_year = Number(_self.user_info.user_info.birthday_year);
						window.console.log(_self.user_info.user_info['birthday_day'])
					}
				})
			},
			saveInfo(){
				var data = this.user_info.user_info;
				data.username = this.user_info.username;
				data.email = this.user_info.email;
				var url = "api/personal/save";
				var _self = this;

				this.POST(url,data,function (ret) {
					if(ret.code === 0){
						_self.$toast(ret.msg);
						setTimeout(function () {
							_self.$router.push('/Personal');
						},500)
					}else{
						_self.$toast(ret.msg);
					}
				})
			}
		},
	}
</script>